import {
    GET_RESPONSE_FAILURE,
    GET_RESPONSE_SUCCESS,
    GET_UNREAD_MESSAGES_COUNT_REQUEST,
    POST_MESSAGE_REQUEST,
    READ_MESSAGE_REQUEST,
    JOIN_ROOM_REQUEST,
    EVENT_ON_JOIN,
    EVENT_ON_MESSAGE,
    EVENT_ON_LEAVE,
    EVENT_ON_READ,
    GET_EVENT_DATA,
    LEAVE_CHAT,
    GET_MESSAGES_REQUEST,
    GET_MESSAGES_SUCCESS,
    GET_MESSAGES_FAILURE,
    RESET_MESSAGES,
    GET_USERS_SUCCESS,
    EVENT_ON_RECONNECT,
    RESET_STATE,
    ON_CONNECT,
    ON_DISCONNECT,
    ON_CONNECT_SUCCESS,
    ON_NEW_USER,
    SET_DENTIST,
    GET_CHAT_DENTISTS,
    GET_CHAT_DENTISTS_SUCCESS,
    GET_CHAT_DENTISTS_FAILURE
} from "./constants";

export function joinChatRoom(userId = null) {
    return {
        type: JOIN_ROOM_REQUEST,
        userId
    }
}

export function sendMessage(data) {
    return {
        type: POST_MESSAGE_REQUEST,
        data
    }
}

export function readMessage(messageId) {
    return {
        type: READ_MESSAGE_REQUEST,
        messageId
    }
}

export function getNumberOfUnreadMessages() {
    return {
        type: GET_UNREAD_MESSAGES_COUNT_REQUEST
    }
}

export function eventOnJoin() {
    return {
        type: EVENT_ON_JOIN
    }
}

export function eventOnMessage(userRole) {    
    return {
        type: EVENT_ON_MESSAGE,
        role: userRole
    }
}

export function eventOnLeave() {
    return {
        type: EVENT_ON_LEAVE
    }
}

export function eventOnRead(role) {
    return {
        type: EVENT_ON_READ,
        role
    }
}

export function getResponseSuccess(data, event) {
    return {
        type: GET_RESPONSE_SUCCESS,
        data,
        event
    }
}

export function getResponseFailure(data) {
    return {
        type: GET_RESPONSE_FAILURE,
        data
    }
}

export function getEventData(data, event) {
    return {
        type: GET_EVENT_DATA,
        data, event
    }
}

export function leaveChatRoom() {
    return {
        type: LEAVE_CHAT
    }
}

export function getMessagesRequest(partnerId, page) {
    return {
        type: GET_MESSAGES_REQUEST,
        partnerId, page
    }
}

export function getMessagesSuccess(data) {
    return {
        type: GET_MESSAGES_SUCCESS,
        data
    }
}

export function getMessagesFailure(data) {
    return {
        type: GET_MESSAGES_FAILURE,
        data
    }
}

export function resetMessages() {
    return {
        type: RESET_MESSAGES
    }
}

export function getUsersForChatSuccess(data) {
    return {
        type: GET_USERS_SUCCESS,
        data
    }
}

export function eventOnReconnect() {
    return {
        type: EVENT_ON_RECONNECT,
    }
}

export function resetState() {
    return {
        type: RESET_STATE
    }
}

export function onConnect() {
    return {
        type: ON_CONNECT
    }
}

export function onDisconnect() {
    return {
        type: ON_DISCONNECT
    }
}

export function onConnectSuccess() {
    return {
        type: ON_CONNECT_SUCCESS
    }
}

export function onNewUser() {
    return {
        type: ON_NEW_USER
    }
}

export function setCurrentDentist(dentist){
    return {
        type: SET_DENTIST,
        data: dentist,
    }
}

export function getChatDentists(data,){
    return {
        type: GET_CHAT_DENTISTS,
        data,
    }
}

export function getChatDentistsSuccess(data,  event){
    return {
        type: GET_CHAT_DENTISTS_SUCCESS,
        data,
        event
    }
}

export function getChatDentistsFailure(data){
    return {
        type: GET_CHAT_DENTISTS_FAILURE,
        data,
    }
}



// WEBPACK FOOTER //
// ./src/containers/Chat/actions.js